import Drawable from './Drawable.js';
import Sprite from '../ui/Sprite.js';
import { imageStore } from '../images.js';
import Pokemon from './Pokemon.js';

export default class StarterPokemonPokeball extends Drawable {
    constructor({ position, identifier, pokemonId, level, id }) {
        super({ position });
        this.pokemonId = pokemonId;
        this.identifier = identifier;
        this.level = level;
        this.id = id;
        this.pokemon = null;
        this.visible = true;
        this.sprite = new Sprite({
            position: this.position,
            image: imageStore.get('img/items/overworld_item.png'),
            moving: false,
            visible: this.visible,
        });
    }

    async createPokemon() {
        this.pokemon = await Pokemon.create({
            id: this.id,
            level: this.level,
        });
        return this.pokemon;
    }

    async getPokemon() {
        if (!this.pokemon) {
            this.pokemon = await this.createPokemon();
        }
        return this.pokemon;
    }

    draw() {
        if (!this.visible) return;
        this.sprite.position = this.effectivePosition();
        this.sprite.draw();
    }

    serialize() {
        return {
            identifier: this.identifier,
            pokemonId: this.pokemonId,
            level: this.level,
            id: this.id,
        };
    }

    static deserialize(data) {
        return new StarterPokemonPokeball({
            identifier: data.identifier,
            pokemonId: data.pokemonId,
            level: data.level,
            id: data.id,
        });
    }
}
